import * as z from "zod";

import { featureFlagKey } from "./keys";

/**
 * Zod schema for a feature-flag key: validates a string and brands it. The key
 * type is intentionally open, so there is no closed set to enumerate.
 */
export const featureFlagKeySchema = z.string().transform(featureFlagKey);
